import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cityFormat'
})
export class CityFormatPipe implements PipeTransform {
    transform(countryCode: String): string {
        if(countryCode === 'No position') {
            return 'No position';
        } else {
            return countryCode?.split(',')[0];
        }
    }
}
